//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import PIApplicationSummary from "@/components/Admin/ProcessInspector/PIApplicationSummary.vue";
import Timeline from "@/components/Flow/timeline.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { eventBus } from "@/assets/js/appFunc";
import TabMessages from "./components/TabMessages.vue";
import TabDocuments from "./components/TabDocuments.vue";
import TabBlockchain from "./components/TabBlockchain.vue";
import TabApi from "./components/TabApi.vue";
import TabDataModel from "./components/TabDataModel.vue";
import TabComments from "./components/TabComments.vue";
/* eslint-disable import/no-extraneous-dependencies */
import "brace/mode/javascript";
import "brace/mode/text";
import "brace/mode/json";
import "brace/theme/tomorrow";
import TabRichText from "./components/TabRichText.vue";

export default {
    components: {
        TabMessages,
        TabDocuments,
        TabDataModel,
        TabApi,
        TabBlockchain,
        TabComments,
        applicationSummary: PIApplicationSummary,
        AQModal,
        Timeline,
        AQDialog,
        TabRichText
    },
    props: {
        selectedInstances: {
            type: Array,
            default() {
                return [];
            }
        },
        multipleSelection: {
            type: Boolean,
            default: false
        },
        isArchiving: {
            type: Boolean,
            default: false
        },
        instanceID: {
            type: String,
            default: ""
        },
        objToSend: {
            type: Object,
            default: () => {}
        },
        applicationName: {
            type: String,
            default: ""
        },
        processDefId: {
            type: String,
            default: ""
        },
        isArchived: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            stackTrace: null,
            instancesAndApps: "",
            activeTab: "dataModel",
            payloadArchiveIds: [],
            needsRefreshTable: false,
            isAchiveDisabled: false,
            isRetryDisabled: false,
            nrOfInstancesApp: {},
            isTerminateDisabled: false,
            processInspectorModal: true,
            isChildSync: false,
            isInstanceInEdit: false,
            hasProcessInformation: {
                label: this.$t("admin.processInspector.refresh"),
                color: "white",
                "text-color": "black"
            },
            hasArchive: {
                label: "Archive",
                color: "positive",
                "text-color": "white"
            },
            processInspectorDescriptionById: {},
            instanceName: "",
            selectedTab: "dataModel",
            systemStatus: "",
            actionFinished: false,
            refreshTimeline: false,
            tab: "dataModel",
            openDialog: false,
            titleDialog: "",
            confirmLabel: "",
            messageTitle: "",
            showDirtyDialog: false
        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById"]),
        tabsProps() {
            return {
                instanceID: this.instanceID,
                instanceName: this.instanceName,
                systemStatus: this.systemStatus,
                isChildSync: this.isChildSync
            };
        },
        appSummaryProps() {
            return {
                instanceID: this.instanceID,
                selectedInstances: this.selectedInstances,
                mode: this.multipleSelection ? "b" : "a",
                isAchiveDisabled: this.isAchiveDisabled,
                isRetryDisabled: this.isRetryDisabled,
                isTerminateDisabled: this.isTerminateDisabled,
                isArchiving: this.isArchiving,
                isArchived: this.isArchived,
                applicationName: this.applicationName,
                processDefId: this.processDefId
            };
        }
    },
    watch: {
        selectedInstances: {
            handler(value) {
                if (value && value.length) {
                    value.forEach(instance => {
                        this.payloadArchiveIds.push(instance.instanceId);
                        this.nrOfInstancesApp[instance.processDefId] = "1";
                    });
                }
            },
            immediate: true
        },
        getProcessInspectorById: {
            handler(newValue) {
                this.processInspectorDescriptionById = newValue;
            },
            immediate: true
        },
        needsRefreshTable: {
            handler(newValue) {
                if (newValue) {
                    this.getProcessInspectorInformation(this.instanceID).then(
                        data => {
                            this.systemStatus = data.data.systemStatus.toUpperCase();
                        }
                    );
                }
            }
        }
    },
    created() {
        if (this.instanceID) {
            this.getProcessInspectorInformation(this.instanceID).then(data => {
                if (data && data.data) {
                    this.instanceName = data.data.instanceName;
                    this.systemStatus = data.data.systemStatus.toUpperCase();
                    this.isChildSync = !data.data.parent && !data.data.childAsync;
                    if (data.data.stackTrace) {
                        this.stackTrace = data.data.stackTrace;
                    }
                }
            });
        }
    },
    methods: {
        ...mapActions("admin", [
            "getProcessInspectorInformation",
            "archiveInstance"
        ]),
        showNotification() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("admin.processInspector.success"),
                timeout: 500
            });
        },
        checkInstanceName(val) {
            this.isInstanceInEdit = val;
        },
        actionDone() {
            this.actionFinished = true;
        },
        changeActionFinished() {
            this.actionFinished = false;
        },
        refreshTimelineDone() {
            this.refreshTimeline = false;
        },
        okAction() {
            const payload = {
                processInstanceIds: this.payloadArchiveIds,
                instanceNumberPerApp: this.nrOfInstancesApp
            };
            this.archiveInstance(payload).then(() => {
                this.needsRefreshTable = true;
                this.showNotification();
                this.$emit(
                    "closeProcessInformationModal",
                    this.needsRefreshTable
                );
            });
            this.isAchiveDisabled = true;
        },
        cancelAction() {
            this.openDialog = false;
        },
        wrnAction(action) {
            if (action === "ok") {
                this.$emit("closeProcessInformationModal", this.needsRefreshTable);
            } else {
                this.showDirtyDialog = false;
            }
        },
        actionsDlg($event) {
            if ($event === "primary") {
                if (this.tab) {
                    eventBus.$emit(`${this.tab}RefreshTab`);
                }
                if (this.isArchiving) {
                    this.openDialog = true;
                    this.titleDialog = this.$t("admin.processInspector.archiveInstance");
                    this.messageTitle = this.$t("admin.processInspector.bulkArchiveMsg");
                    this.confirmLabel = this.multipleSelection ? `${this.$t("admin.processInspector.archive")} (${this.selectedInstances.length})`
                        : this.$t("admin.processInspector.archive");
                } else if (!this.isArchiving) {
                    this.getProcessInspectorInformation(this.instanceID).then(
                        data => {
                            this.systemStatus = data.data.systemStatus.toUpperCase();
                        }
                    );
                    this.refreshTimeline = true;
                    this.isRetryDisabled = false;
                }
            } else if ($event === "close") {
                if (this.isInstanceInEdit) {
                    this.showDirtyDialog = true;
                } else {
                    this.$emit(
                        "closeProcessInformationModal",
                        this.needsRefreshTable
                    );
                }
            }
        },

        nrOfInstancesAndApps(event) {
            this.instancesAndApps = event.substr(0, event.length - 9);
        },
        nrOfInstancesPerApps(event) {
            this.nrOfInstancesApp = event;
        },
        closeProcessInspectorModal() {
            this.$emit("closeProcessInformationModal", true);
        },
        selectTab(tab) {
            this.activeTab = tab;
        }
    }
};
